import React from "react";
import Axios from 'axios'
import AdminTemplate from "./AdminTemplate";
import moment from 'moment';
import API from '../Utils/api'

export class AdminRelatorios extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      relatorioGeral: { totalDeCartelas: 0, totalFaturado: 0, totalComissoesCambista: 0, totalComissaoGerente: 0, totalEmCAvulsas: 0, totalEmCOnlone: 0 },
      pedidos: [],
      tabelaRelatorio: [],
      historicos: [],
      gerentes: [],
      historicoSelecionado: undefined,
      gerenteSelecionado: undefined,
      cambistaSelecionado: undefined,
      parametros: undefined,
      isLoad: true,
      isApp: false,
      isPanfleto: false
    };
    this.getHistoricos();
    this.getGerentes();
    this.getParametros();
  }

  async getParametros() {
    try {
      const response = await API.get("/api/parametros/");
      this.setState({ parametros: response.data });

    } catch (err) {
      console.log(err);
    }
  }

  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  compararNome2(a, b) {
    if (a[1].nome.toLowerCase() > b[1].nome.toLowerCase()) {
      return 1;
    }
    if (a[1].nome.toLowerCase() < b[1].nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  compararDatas(a, b) {
    var A = new Date(a.dataInicial)
    var B = new Date(b.dataInicial)
    if (A < B) {
      return 1;
    }
    if (A > B) {
      return -1;
    }

    return 0
  }

  async getGerentes() {

    try {
      const response = await API.post("/api/usuarios/listar-todos-admin-gerentes-ativos", {userId: this.state.user._id});
      this.setState({ gerentes: [this.state.user, ...response.data.sort(this.compararNome)] });

    } catch (err) {
      console.log(err);
    }
  };
  async getHistoricos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      })
      const response = await axiosInstance.get("historicos/")

      this.setState({ historicos: response.data.sort(this.compararDatas) })

    } catch (err) {
      console.log(err)
    }
  }

  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  selecionaIntervalo(e) {
    if (e.target.value !== 'NULL') {
      this.setState({ historicoSelecionado: JSON.parse(e.target.value).historico, pedido: [], tabelaRelatorio: [] })
      this.buscarPedidosIntervalo(JSON.parse(e.target.value).historico);
    }
    else {
      this.setState({ historicoSelecionado: undefined, gerenteSelecionado: undefined, cambistaSelecionado: undefined })
    }
  }

  setGerente(e) {

    if (e.target.value !== 'NULL') {
      this.setState({ gerenteSelecionado: JSON.parse(e.target.value), cambistaSelecionado: undefined })
    }
    else {
      this.setState({ gerenteSelecionado: undefined, cambistaSelecionado: undefined })
    }

    this.forceUpdate()

  }

  async buscarPedidosIntervalo(historicoSelecionado) {
    if (historicoSelecionado) {
      this.setState({ isLoad: true })
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        })
        const response = await axiosInstance.post("pedidos/intervalo-admin",
          {
            dataInicial: historicoSelecionado.dataInicial,
            dataFinal: historicoSelecionado.dataFinal,
            isApp: this.state.isApp,
            isPanfleto: this.state.isPanfleto,
            adminId: this.state.user._id
          })

        this.setState({ pedidos: response.data.reverse() })
        if (response.data) {
          this.setState({ isLoad: false })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }

  gerarRelatorio = () =>{
    var tabelaRelatorio = {};
    if (this.state.gerenteSelecionado == undefined && this.state.cambistaSelecionado == undefined) {
      this.state.pedidos.map(pedido => {
        if (tabelaRelatorio[pedido.gerenteId.nome] == undefined)
          tabelaRelatorio[pedido.gerenteId.nome] = { nome: pedido.gerenteId.nome, qtdCartelas: 0, faturamento: 0, totTaxasGerente: 0, totTaxasCambistas: 0, saldo: 0, totCAvulsas: 0, totCOnline : 0 }
        tabelaRelatorio[pedido.gerenteId.nome].qtdCartelas += pedido.cartelas.length;
        tabelaRelatorio[pedido.gerenteId.nome].faturamento += pedido.cartelas.length * this.state.historicoSelecionado.valorCartelasLote;
        tabelaRelatorio[pedido.gerenteId.nome].totTaxasCambistas += pedido.cartelas.length * this.state.parametros.baseComissaoCambista;
        tabelaRelatorio[pedido.gerenteId.nome].totTaxasGerente += pedido.cartelas.length * this.state.parametros.baseComissaoGerente;
        tabelaRelatorio[pedido.gerenteId.nome].saldo = tabelaRelatorio[pedido.gerenteId.nome].faturamento - tabelaRelatorio[pedido.gerenteId.nome].totTaxasCambistas - tabelaRelatorio[pedido.gerenteId.nome].totTaxasGerente;

        if (pedido.transacaoId.tipo === 'Venda' && pedido.transacaoId.documento == 'Documento Avulso')
          tabelaRelatorio[pedido.gerenteId.nome].totCAvulsas += parseFloat(pedido.transacaoId.valor);
        if (pedido.transacaoId.tipo === 'Venda' && pedido.transacaoId.documento !== 'Documento Avulso')
          tabelaRelatorio[pedido.gerenteId.nome].totCOnline += parseFloat(pedido.transacaoId.valor);
      })
    }
    else if (this.state.gerenteSelecionado != undefined && this.state.cambistaSelecionado == undefined) {
      this.state.pedidos.map(pedido => {
        if (this.state.gerenteSelecionado._id == pedido.gerenteId._id) {
          if (tabelaRelatorio[pedido.cambistaId?.nome] == undefined)
            tabelaRelatorio[pedido.cambistaId.nome] = { nome: pedido.cambistaId.nome, qtdCartelas: 0, faturamento: 0, totTaxasGerente: 0, totTaxasCambistas: 0, saldo: 0, totCAvulsas: 0, totCOnline : 0 }
          tabelaRelatorio[pedido.cambistaId.nome].qtdCartelas += pedido.cartelas.length;
          tabelaRelatorio[pedido.cambistaId.nome].faturamento += pedido.cartelas.length * this.state.historicoSelecionado.valorCartelasLote;
          tabelaRelatorio[pedido.cambistaId.nome].totTaxasCambistas += pedido.cartelas.length * this.state.parametros.baseComissaoCambista;
          tabelaRelatorio[pedido.cambistaId.nome].saldo = tabelaRelatorio[pedido.cambistaId.nome].faturamento - tabelaRelatorio[pedido.cambistaId.nome].totTaxasCambistas;
          console.log(pedido.transacaoId)
          if (pedido.transacaoId.tipo === 'Venda' && pedido.transacaoId.documento == 'Documento Avulso')
          tabelaRelatorio[pedido.cambistaId.nome].totCAvulsas += parseFloat(pedido.transacaoId.valor);
          if (pedido.transacaoId.tipo === 'Venda' && pedido.transacaoId.documento !== 'Documento Avulso')
            tabelaRelatorio[pedido.cambistaId.nome].totCOnline += parseFloat(pedido.transacaoId.valor);
        }
      })
    }
    var totalDeCartelas = 0;
    var totalFaturado = 0;
    var totalComissoesCambista = 0;
    var totalComissaoGerente = 0;
    var totalEmCAvulsas = 0;
    var totalEmCOnlone = 0;
    Object.entries(tabelaRelatorio).map(item => {
      totalDeCartelas += item[1].qtdCartelas;
      totalEmCAvulsas += item[1].totCAvulsas;
      totalEmCOnlone += item[1].totCOnline;
      totalFaturado += item[1].faturamento;
      totalComissoesCambista += item[1].totTaxasCambistas;
      totalComissaoGerente += item[1].qtdCartelas * this.state.parametros.baseComissaoGerente;
    });
    this.setState({ tabelaRelatorio: Object.entries(tabelaRelatorio).sort(this.compararNome2), relatorioGeral: { totalDeCartelas, totalFaturado, totalComissoesCambista, totalComissaoGerente, totalEmCAvulsas, totalEmCOnlone } });
  }


  handlerRelatorioByApp (e){
    this.state.isApp = e.target.checked;
    this.setState({isApp : e.target.checked, isLoad: false, isPanfleto : this.state.isApp? this.state.isPanfleto : false})
    this.buscarPedidosIntervalo(this.state.historicoSelecionado);
  }

  handlerRelatorioByPanfleto (e){
    this.state.isPanfleto = e.target.checked;
    this.setState({isPanfleto : e.target.checked, isLoad: false})
    this.buscarPedidosIntervalo(this.state.historicoSelecionado);
  }
  render() {
    return (
      <AdminTemplate label="Relatorios">
        {/* {this.state.isLoad ? <LoadCircle></LoadCircle> : ""} */}

        <div className="container-fluid">
          <div className="controle-relatorio" style={{ alignItems: 'center'}}>
            <select onChange={this.selecionaIntervalo.bind(this)} className="custom-select">
              <option value={'NULL'} selected >Selecione um intervalo</option>
              {this.state.historicos.map(historico => {
                return <option value={JSON.stringify({ historico })}>{this.formatDate(historico.dataInicial)} ➨ {this.formatDate(historico.dataFinal)} </option>
              })}
            </select>
            <select onChange={this.setGerente.bind(this)} disabled={this.state.historicoSelecionado == undefined ? true : false} className="ml-1 custom-select">
              <option value={'NULL'} selected>Todos os gerentes</option>
              {this.state.gerentes.length > 0 ? this.state.gerentes.map(gerente => {
                return <option value={JSON.stringify(gerente)}>{gerente.nome.substring(0, 60)}...</option>
              }) : ""}
            </select>
          
            <button className="ml-1" disabled={this.state.isLoad == true ? true : false} onClick={() => this.gerarRelatorio()} >Gerar relatório</button>
              <div style={{border: "1px solid gray", borderRadius: "3px", marginLeft: "12px", display: "flex", alignItems: "center", textAlign: "center", paddingRight: "4px"}}>
                <input type="checkbox" style={{marginLeft: 6, width: 22, height: 22, fontSize: 12}} onChange={this.handlerRelatorioByApp.bind(this)}></input>
                <label style={{marginLeft: 6, fontWeight: 'bold', fontSize: 12, marginTop: 8}}>apenas App</label>
              </div>
              
              <div style={{border: "1px solid gray", borderRadius: "3px", marginLeft: "12px", display: "flex", alignItems: "center", textAlign: "center", paddingRight: "4px"}}>
                <input type="checkbox" style={{marginLeft: 6, width: 22, height: 22, fontSize: 12}} onChange={this.handlerRelatorioByPanfleto.bind(this)}></input>
                <label style={{marginLeft: 6, fontWeight: 'bold', fontSize: 12, marginTop: 8}}>apenas Panfleto</label>
              </div>
          </div>
          <div className="scrollControll">
            <table className="tabela-template mt-3">
              <tr>
                <th>Total de cartelas</th>
                {/* <th>Total em cartelas avulsas</th> */}
                <th>Total em cartelas online</th>
                <th>Total faturado</th>
                <th>Total comissões para vendedores</th>
                <th className={this.state.gerenteSelecionado != undefined ? 'd-none' : ''} >Total comissões para gerentes</th>
                <th className={this.state.gerenteSelecionado == undefined ? 'd-none' : ''} >Comissão do gerente</th>
                <th className={this.state.gerenteSelecionado != undefined ? 'd-none' : ''} >Saldo final total</th>
                <th className={this.state.gerenteSelecionado == undefined ? 'd-none' : ''} >Repasse para a banca</th>
              </tr>
              <tr>
                <td>{this.state.relatorioGeral.totalDeCartelas}</td>
                {/* <td>R$ {parseFloat(this.state.relatorioGeral.totalEmCAvulsas).toFixed(2)}</td> */}
                <td>R$ {parseFloat(this.state.relatorioGeral.totalEmCOnlone).toFixed(2)}</td>
                <td>R$ {parseFloat(this.state.relatorioGeral.totalFaturado).toFixed(2)}</td>
                <td>R$ {parseFloat(this.state.relatorioGeral.totalComissoesCambista).toFixed(2)}</td>
                <td>R$ {parseFloat(this.state.relatorioGeral.totalComissaoGerente).toFixed(2)}</td>
                <td>R$ {parseFloat(this.state.relatorioGeral.totalFaturado - this.state.relatorioGeral.totalComissoesCambista - this.state.relatorioGeral.totalComissaoGerente).toFixed(2)}</td>
              </tr>
            </table>
            <table className="tabela-template mt-1">
              <tr>
                <th>Colaboradores</th>
                <th>Qtd. Cartelas</th>
                {/* <th>Faturado avulso</th> */}
                <th>Faturado online</th>
                <th>Faturamento</th>
                <th className={this.state.gerenteSelecionado != undefined ? 'd-none' : ''}>Total taxas Gerente</th>
                <th>Total taxas Cambistas</th>
                <th>Saldo Final</th>
              </tr>
              {this.state.tabelaRelatorio.map(item => {
                return (
                  <tr>
                    <td className="pl-1">{item[1].nome}</td>
                    <td>{item[1].qtdCartelas}</td>
                    {/* <td>R$ {parseFloat(item[1].totCAvulsas).toFixed(2)}</td> */}
                    <td>R$ {parseFloat(item[1].totCOnline).toFixed(2)}</td>
                    <td>R$ {parseFloat(item[1].faturamento).toFixed(2)}</td>
                    <td className={this.state.gerenteSelecionado != undefined ? 'd-none' : ''} >R$ {parseFloat(item[1].totTaxasGerente).toFixed(2)}</td>
                    <td >R$ {parseFloat(item[1].totTaxasCambistas).toFixed(2)}</td>
                    <td>R$ {parseFloat(item[1].saldo).toFixed(2)}</td>
                  </tr>)
              })}

            </table>
          </div>

        </div>
      </AdminTemplate>
    );
  }
}

export default AdminRelatorios;
